(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var overlay = qs('[data-drawer-overlay]');

  function showOverlay(onClick) {
    if (!overlay) return;
    overlay.hidden = false;
    overlay.onclick = onClick;
  }
  function hideOverlay() {
    if (!overlay) return;
    overlay.hidden = true;
    overlay.onclick = null;
  }

  /* ---------------- Mobile menu ---------------- */
  var mobileMenu = qs('[data-mobile-menu]');
  qsa('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mobileMenu) mobileMenu.hidden = false;
    });
  });
  qsa('[data-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mobileMenu) mobileMenu.hidden = true;
    });
  });

  /* ---------------- Search drawer ---------------- */
  var searchDrawer = qs('#search-drawer');
  qsa('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!searchDrawer) return;
      searchDrawer.hidden = false;
      showOverlay(closeSearch);
      var input = qs('input[type="search"]', searchDrawer);
      if (input) input.focus();
    });
  });
  function closeSearch() {
    if (searchDrawer) searchDrawer.hidden = true;
    hideOverlay();
  }
  qsa('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', closeSearch);
  });

  /* ---------------- Announcement bar ---------------- */
  qsa('[data-announcement-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var bar = btn.closest('[data-announcement-bar]');
      if (bar) bar.style.display = 'none';
    });
  });
  qsa('[data-announcement-bar]').forEach(function (bar) {
    var items = qsa('.announcement-bar__item', bar);
    var speed = parseInt(bar.getAttribute('data-autoplay'), 10);
    if (items.length < 2 || !speed) return;
    var current = 0;
    setInterval(function () {
      items[current].classList.remove('is-active');
      current = (current + 1) % items.length;
      items[current].classList.add('is-active');
    }, speed * 1000);
  });

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = qs('[data-cart-drawer]');

  function openCartDrawer() {
    if (!cartDrawer) { window.location.href = '/cart'; return; }
    cartDrawer.hidden = false;
    requestAnimationFrame(function () { cartDrawer.classList.add('is-open'); });
    showOverlay(closeCartDrawer);
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    hideOverlay();
    setTimeout(function () { cartDrawer.hidden = true; }, 300);
  }
  qsa('[data-cart-toggle]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (cartDrawer) { e.preventDefault(); openCartDrawer(); }
    });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) closeCartDrawer();
  });

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function refreshCartDrawer() {
    fetch('/?sections=cart-drawer')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!cartDrawer || !html) return;
        var wasOpen = cartDrawer.classList.contains('is-open');
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newDrawer = temp.querySelector('[data-cart-drawer]');
        if (newDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
          cartDrawer.hidden = false;
          if (wasOpen) cartDrawer.classList.add('is-open');
        }
      })
      .catch(function () {});
  }

  /* Add to cart (AJAX) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#ProductForm');
    if (!form) return;
    e.preventDefault();
    var btn = qs('[data-add-to-cart]', form);
    var textEl = qs('[data-add-to-cart-text]', btn);
    var originalText = textEl ? textEl.textContent : '';
    if (btn) btn.disabled = true;
    if (textEl) textEl.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.fromEntries(new FormData(form)))
    })
      .then(function (res) { return res.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        refreshCartDrawer();
        openCartDrawer();
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        if (btn) btn.disabled = false;
        if (textEl) textEl.textContent = originalText;
      });
  });

  /* Cart drawer quantity / remove (event delegation) */
  document.addEventListener('click', function (e) {
    var item = e.target.closest('[data-cart-item]');
    if (!item || !cartDrawer || !cartDrawer.contains(item)) return;
    var line = parseInt(item.getAttribute('data-line'), 10);
    var qtyEl = qs('[data-qty-value]', item);
    var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var newQty = null;

    if (e.target.closest('[data-qty-increase]')) newQty = currentQty + 1;
    if (e.target.closest('[data-qty-decrease]')) newQty = Math.max(0, currentQty - 1);
    if (e.target.closest('[data-qty-remove]')) newQty = 0;

    if (newQty === null) return;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: newQty })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        refreshCartDrawer();
      })
      .catch(function () {});
  });

  /* ---------------- Hero slideshow ---------------- */
  qsa('[data-hero-slideshow]').forEach(function (hero) {
    var slides = qsa('[data-hero-slide]', hero);
    if (slides.length < 2) return;
    var current = 0;
    var currentEl = qs('[data-hero-current]', hero);

    function show(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (currentEl) currentEl.textContent = current + 1;
    }

    var prevBtn = qs('[data-hero-prev]', hero);
    var nextBtn = qs('[data-hero-next]', hero);
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });

    var autoplay = parseInt(hero.getAttribute('data-autoplay'), 10);
    if (autoplay > 0) {
      setInterval(function () { show(current + 1); }, autoplay * 1000);
    }
  });

  /* ---------------- Product gallery ---------------- */
  qsa('[data-product-gallery]').forEach(function (gallery) {
    var slides = qsa('[data-gallery-slide]', gallery);
    if (slides.length < 2) return;
    var current = 0;
    var currentEl = qs('[data-gallery-current]', gallery);

    function show(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (currentEl) currentEl.textContent = current + 1;
    }

    var prevBtn = qs('[data-gallery-prev]', gallery);
    var nextBtn = qs('[data-gallery-next]', gallery);
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });

    /* Jump to a specific image (used by the variant picker) */
    gallery.addEventListener('gallery:goto', function (e) {
      var id = String(e.detail && e.detail.mediaId);
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === id) { show(i); return; }
      }
    });
  });

  /* ---------------- Variant picker ---------------- */
  qsa('.product').forEach(function (productEl) {
    var form = qs('#ProductForm', productEl);
    var jsonEl = qs('[data-product-json]', productEl);
    if (!form || !jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var prices = {};
    var pricesEl = qs('[data-variant-prices]', productEl);
    if (pricesEl) { try { prices = JSON.parse(pricesEl.textContent); } catch (err) {} }

    var groups = qsa('.product__option', form);
    var gallery = qs('[data-product-gallery]', productEl);

    function selectedValues() {
      return groups.map(function (group) {
        var selected = qs('.option-value.is-selected', group);
        return selected ? selected.getAttribute('data-value') : null;
      });
    }

    function findVariant() {
      var values = selectedValues();
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return values.every(function (val, i) { return val === null || opts[i] === val; });
      });
    }

    function updateUI() {
      var variant = findVariant();
      var priceEl = qs('[data-product-price]', productEl);
      var idInput = qs('[data-product-variant-id]', form);
      var addBtn = qs('[data-add-to-cart]', form);
      var addText = qs('[data-add-to-cart-text]', addBtn);

      if (variant) {
        if (idInput) idInput.value = variant.id;
        if (priceEl && prices[variant.id]) priceEl.innerHTML = prices[variant.id];
        if (addBtn) addBtn.disabled = !variant.available;
        if (addText) addText.textContent = variant.available ? (window.themeStrings && window.themeStrings.addToCart || 'Add to Cart') : (window.themeStrings && window.themeStrings.soldOut || 'Sold Out');
        if (gallery && variant.featured_image && variant.featured_image.id) {
          gallery.dispatchEvent(new CustomEvent('gallery:goto', { detail: { mediaId: variant.featured_image.id } }));
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(null, '', url.toString());
        } catch (err) {}
      } else {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = window.themeStrings && window.themeStrings.unavailable || 'Unavailable';
      }
    }

    qsa('[data-option-value]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.product__option');
        qsa('.option-value', group).forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        updateUI();
      });
    });
  });
})();